import axios from "../utils/axios";

export const authorizeAmazonUser = async (payload) => {
  const response = await axios.post("/amazon/token", payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};
export const updateAllProducts = async (paylod = {}) => {
  const response = await axios.put(
    `/amazon/update/listing`, paylod,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response;
};

export const updateProductBulletPoints = async (payload) => {
  const response = await axios.put(
    `/amazon/update/listing/item/bullet/points`, payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response;
};

export const fetchAplusContent = async (productId) => {
  try {
    const response = await axios.get(`/amazon/get-aplus-content`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          product_id: productId,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching competitor products:", error);
    throw error;
  }
};

export const updateAplusContent = async (payload) => {
  try {
    const response = await axios.post(`/amazon/update-aplus-content`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching competitor products:", error);
    throw error;
  }
};

export const fetchLinkedAsins = async (productId) => {
  try {
    const response = await axios.get(`/amazon/get-linked-asins`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          product_id: productId,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching competitor products:", error);
    throw error;
  }
};
export const generateAmazonAuthorization = async (id) => {
  try {
    const response = await axios.get(`/amazon/authrizaiton-link/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching competitor products:", error);
    throw error;
  }
};

export const skipAuthorization = async () => {
  try {
    const response = await axios.post(`/amazon/skip-authorization`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error skipping authorization:", error);
    throw error;
  }
};


export const fetchFeeds = async () => {
  try {
    const response = await axios.get(`/amazon/feeds`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching competitor products:", error);
    throw error;
  }
};

export const updateProductTitle = async (id, payload) => {
  const response = await axios.put(
    `amazon/update-title/${id}`, payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response;
};

export const updateProductDescription = async (productId, description) => {
  const response = await axios.put(
    '/amazon/listings/update',
    {
      productId: Number(productId),
      description: description
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response;
};

export const updateBackendKeywords = async (productId, keywordsText) => {
  const response = await axios.put(
    '/amazon/listings/update',
    {
      productId: Number(productId),
      backendKeywords: [keywordsText]
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response;
};